import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { getGradient } from '@twistopayments/design-system/theme';

export const root = (theme: Theme) => css`
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: ${theme.borderRadius.sm};
  padding: ${theme.spacing[8]} ${theme.spacing[16]};
  font-weight: inherit;
  width: 100%;
  border: none;
  background: transparent;
`;

export const clickable = (theme: Theme) => css`
  cursor: pointer;

  &:hover {
    background: ${getGradient(theme, 'linearGray')};
  }

  &:focus,
  &:active,
  &:focus-within {
    background: ${getGradient(theme, 'linearGray', 200)};
  }
`;

export const noPadding = css`
  padding: 0;
`;
